import { isEqual } from '../../utils/helpers/isEqual'

function intersectionWith(firstArray) {
  const otherArrays = Array.prototype.slice.call(arguments, 1, -1)
  const comparator = arguments[arguments.length - 1]
  return firstArray.filter((a) => {
    return otherArrays.every((arr) => {
      return arr.some((b) => {
        return comparator(a, b)
      })
    })
  })
}

export default function getSelectOptionsFiltered(filteringState, items) {
  const data = []

  if (filteringState === {} || !items) return false
  Object.entries(filteringState).forEach((filter) => {
    const item = filter[1].itemProps
    const value = filter[1].value
    const filteredItems = []

    const selectedOption = item?.options.filter((str) => {
      return str.value.toString() === value.toString()
    })
    const selectedRelations = selectedOption?.[0]?.relations ? JSON.parse(selectedOption?.[0]?.relations) : false
    if (!selectedRelations) return false
    Object.entries(selectedRelations).forEach((relation) => {
      const relationKey = relation[0]
      const relationItem = items.filter((obj) => obj.name === relationKey)
      const relationItemOptions = relationItem?.[0]?.options

      const filteredOptions = []
      if (relationItemOptions) {
        const filteredItemsDefaultOption = relationItemOptions.filter((obj) => obj.value === '')
        filteredOptions.push(filteredItemsDefaultOption[0])
        if (
          Object.keys(selectedRelations[relationKey]).length !== 0 &&
          selectedRelations[relationKey].constructor !== Object
        ) {
          selectedRelations[relationKey].forEach((option) => {
            const filteredItem = relationItemOptions.filter((obj) => obj.value === option.id)
            if (filteredItem[0]) filteredOptions.push(filteredItem[0])
          })
        }

        filteredItems[relationKey] = filteredOptions
      }
    })

    if (filteredItems !== []) {
      Object.entries(filteredItems).forEach((relation) => {
        const relationKey = relation[0]
        if (data[relationKey]) {
          const intersection = intersectionWith(data[relationKey], filteredItems[relationKey], isEqual)
          data[relationKey] = intersection
        } else {
          data[relationKey] = filteredItems[relationKey]
        }
      })
    }
  })

  return data
}
